import { render, staticRenderFns } from "./WebQR.vue?vue&type=template&id=36dd4994&scoped=true&"
import script from "./WebQR.vue?vue&type=script&lang=js&"
export * from "./WebQR.vue?vue&type=script&lang=js&"
import style0 from "./WebQR.vue?vue&type=style&index=0&id=36dd4994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd4994",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRadio,VRadioGroup,VSkeletonLoader,VTooltip})
